import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";

const state = {};

const getters = {};

const actions = {
  getRecipients({ state }, options) {
    var settings = SettingsService.settings;
    var url = settings.APIURL + `plans/${options.planIdentityId}/reports/${options.reportType}/recipients?$expand=User($select=FirstName,LastName,Email),UserReportSettingsEmployers($select=EmployerId),UserReportSettingsStores($select=StoreId)&$select=Id`;
    return ApiService.get(url);
  },

  sendBulkReportEmail({ state }, { planId, payload }) {
    var settings = SettingsService.settings;
    var url = settings.APIURL + `users/${planId}/report-email`;
    return ApiService.post(url, payload);
  },
  sendReportEmail({ state }, email) {
    var settings = SettingsService.settings;
    var url = settings.APIURL + "api/reports/send";
    return ApiService.post(url, email);
  },
  postAdjustmentAction({ state }, options) {
    var settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/adjustments/" +
        options.action,
      {
        Ids: options.adjustments,
        TermId: options.term.Id,
        TermName: options.term.Name,
        TermNumber: options.term.Number,
        TermStart: options.term.StartDate,
        TermEnd: options.term.EndDate,
      }
    );
  },
  // eslint-disable-next-line
  calculate({ state }, options) {
    var settings = SettingsService.settings;
    return ApiService.get(
      settings.APIURL +
        "plans/" +
        options.plan +
        "/term/" +
        options.term +
        "/calculate/"
        + options.skip
    );
  },
  // eslint-disable-next-line
  calculateRevise({ state }, options) {
    var settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "plans/" + options.plan + "/term-revise-calculate",
      options.payload
    );
  },
  getEmailReport({ state }, opts) {
    var settings = SettingsService.settings;
    var url = `${settings.APIURL}plans/${
      opts.plan
    }/${opts.reportType.toLowerCase()}/reports/archive?$expand=BillingTerm($select=Number,Name,Id;$expand=Translations($select=LanguageCode,Id,Name))&$select=Id,BillingTermId,PlanId,Version,Timestamp,CreatorEmail&$filter=Id eq ` + opts.reportId;
    return ApiService.get(url);
  },
  // eslint-disable-next-line
  getReport({ state }, options) {
    var settings = SettingsService.settings;
    console.log(options);
    return ApiService.post(
      settings.APIURL + "premiums/getReport",
      options.payload
    );
  },
  getContributionsReport({ state }, options) {
    var settings = SettingsService.settings;
    return ApiService.post(
      settings.APIURL + "premiums/getReport",
      options.payload
    );
  },
  // eslint-disable-next-line
  reviseReport({ state }, options) {
    var settings = SettingsService.settings;
    var url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/t4a/reports/" +
      options.report.Id +
      "/revise";

    //url="http://localhost:5010/api/TaxedPremiums/ReviseReport/b6211967-ba72-43fe-b9f3-08d759471189"
    return ApiService.post(url);
  },
  adjustmentsForTaxYear({ state }, options) {
    var settings = SettingsService.settings;
    var url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/taxYear/" +
      options.taxYearId +
      "/members/adjustments";
    return ApiService.get(url);
  },
  adjustmentsExist({ state }, options) {
    var settings = SettingsService.settings;
    var url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/term/" +
      options.termId +
      "/members/adjustments-exist";
    return ApiService.get(url);
  },
  adjustmentsExistRevise({ state }, options) {
    var settings = SettingsService.settings;
    var url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/adjustments/revised-adjustments-exist";
    return ApiService.post(url, options.payload);
  },
  getAdjustments({ state }, options) {
    var settings = SettingsService.settings;
    var url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/term/" +
      options.term +
      "/members/adjustments?$filter=Status eq 'Pending'";
    return ApiService.get(url);
  },
  getInsuranceCarrierCoverageGroups({ commit }, options) {
    //console.log(options)
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/reports/" +
      options.reportId +
      "/insuranceCarriers/coverageGroups";
    return ApiService.post(url, options.insuranceCarrierIds);
  },
  getTrustfundCoverageGroups({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/reports/" +
      options.reportId +
      "/trustfund/coverageGroups";
    return ApiService.get(url);
  },
  getPlanCoverageGroups({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planId +
      "/reports/" +
      options.reportId +
      "/coverageGroups";
    return ApiService.get(url);
  },
  getUserReportsConfigurations({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "users/" + options.userId + "/user-reports-settings";
    return ApiService.get(url);
  },
  getUserReportsConfigurationsForPlan({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "users/" + options.userId + "/user-reports-settings/" + options.planId;
    return ApiService.get(url);
  },
  saveUserReportsConfiguration({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "users/" + options.userId + "/user-reports-settings";
    return ApiService.post(url, options.payload);
  },
};

const mutations = {};

export const transactions = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
